import React from 'react';

const PaymentStatusBadge = ({ paymentStatus, className = '' }) => {
  const getStatusConfig = (status) => {
    const configs = {
      'not_requested': {
        label: 'טרם נדרש תשלום',
        bgColor: 'bg-gray-100',
        textColor: 'text-gray-800',
        icon: '⏳'
      },
      'pending': {
        label: 'ממתין לתשלום',
        bgColor: 'bg-yellow-100',
        textColor: 'text-yellow-800',
        icon: '⏰'
      },
      'completed': {
        label: 'שולם',
        bgColor: 'bg-green-100',
        textColor: 'text-green-800',
        icon: '✅'
      },
      'failed': {
        label: 'תשלום נכשל',
        bgColor: 'bg-red-100',
        textColor: 'text-red-800',
        icon: '❌'
      },
      'expired': {
        label: 'קישור תשלום פג',
        bgColor: 'bg-orange-100',
        textColor: 'text-orange-800',
        icon: '⏰'
      },
      'cancelled': {
        label: 'תשלום בוטל',
        bgColor: 'bg-gray-100',
        textColor: 'text-gray-800',
        icon: '🚫'
      }
    };

    return configs[status] || configs['not_requested'];
  };

  const config = getStatusConfig(paymentStatus);

  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${config.bgColor} ${config.textColor} ${className}`}>
      <span className="ml-1">{config.icon}</span>
      {config.label}
    </span>
  );
};

export default PaymentStatusBadge;